import Skeleton from "react-loading-skeleton";

const FIELD_ROWS = 6;

// opaque so the editor's own boot screen stays hidden until it reports ready
export function BnxtEditorSkeleton() {
    return (
        <div className="position-absolute top-0 start-0 w-100 h-100 p-16 aw:bg-white" data-cy="bnxtEditor.skeleton">
            <Skeleton height={32} width="40%" className="mb-24"/>
            <div className="d-flex gap-24">
                {[0, 1].map((column) => (
                    <div key={column} className="w-50">
                        {Array.from({length: FIELD_ROWS}, (_, row) => (
                            <div key={row} className="mb-16">
                                <Skeleton height={12} width="30%"/>
                                <Skeleton height={32}/>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default BnxtEditorSkeleton;
